import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { CompletionGuard } from './CompletionGuard';

/**
 * Checks if student onboarding is complete before rendering student routes.
 * Only applies to approved students — admins, teachers, and pending students bypass.
 */
export const StudentOnboardingGuard = ({ children }) => {
  const { isStudent, isApproved } = useAuth();

  return (
    <CompletionGuard
      shouldCheck={isStudent && isApproved}
      endpoint="/api/student/onboarding"
      redirectTo="/student/onboarding"
      backgroundClass="bg-[#F8F9FC]"
    >
      {children}
    </CompletionGuard>
  );
};

export default StudentOnboardingGuard;
